import { defineMessages } from 'react-intl';

const scope = 'app.workspace.deleteImportList';

export default defineMessages({
  delete: {
    id: `${scope}.delete`,
    defaultMessage: 'Delete',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  deleteConfirmationDescription: {
    id: `${scope}.deleteConfirmationDescription`,
    defaultMessage: 'This will terminate the import and remove it from the import history.',
  },
  deleteConfirmationTitle: {
    id: `${scope}.deleteIngestionConfirmationTitle`,
    defaultMessage: 'Are you sure you want to cancel import?',
  },
  deleteImport: {
    id: `${scope}.deleteImport`,
    defaultMessage: 'Delete Import',
  },
  deleteConfirmImportingStatus: {
    id: `${scope}.deleteConfirmImportingStatus`,
    defaultMessage: 'This will terminate the import and remove it from the importing status.',
  },
});
